import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';
import { PaperUI } from '../../components';

export default makeStyles({
  headerResumo: {
    textAlign: 'center',
  },
  dialogEditarNotaFiscal: {
    ' & .MuiDialog-paperWidthSm': {
      maxWidth: '585px',
    },
  },
});

export const ContainerPrincipal = styled(PaperUI)`
  padding: 22px;
  height: 100%;
`;

export const ContainerResumo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: stretch;

  > div {
    display: flex;
    justify-content: center;

    > p {
      font-family: Roboto, sans-serif;
      font-weight: bold;
      font-size: 16px;
    }
  }

  > div {
    gap: 8px;
  }
`;


export const CardFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  height: 52px;
  border-radius: 10px;

  background-color: ${props => props.color};

  p {
    display: block;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-size: 12px;
    line-height: 14px;
    color: #FFFFFF;
  }

  p:first-child {
    padding-top: 5px;
    margin-Top: 8px;
    font-size: 14px;
    font-weight: bold;
  }

  p:last-child {
    padding-top: 7px;
    padding-bottom: 13px;
    font-size: 16px;
    font-weight: 500;
  }
`;
